/* ==========================================================================
   LZ FAQ — recherche instantanée, filtres par catégorie, accordéon, ancres
   Tout le contenu est déjà dans le HTML (SEO) : ce script ne fait que masquer.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var roots = document.querySelectorAll('.lz-faq');
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, function (root) {
      if (root._lzFaqInit) return;
      root._lzFaqInit = true;
      initRoot(root);
    });
  }

  function initRoot(root) {

    var input = root.querySelector('.lz-faq__search-input');
    var clearBtn = root.querySelector('.lz-faq__search-clear');
    var countEl = root.querySelector('[data-count]');
    var noResult = root.querySelector('.lz-faq__noresult');
    var filters = Array.prototype.slice.call(root.querySelectorAll('.lz-faq__filter'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.lz-faq__group'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.lz-faq__item'));

    // Index de recherche : texte brut question + réponse, sans accents
    items.forEach(function (item) {
      var q = item.querySelector('.lz-faq__question-text');
      var a = item.querySelector('.lz-faq__answer');
      item._q = q;
      item._qHtml = q.innerHTML;
      item._text = normalize((q.textContent || '') + ' ' + (a ? a.textContent : ''));
    });

    // Tri par le champ `ordre` (puis alphabétique) à l'intérieur de chaque groupe
    groups.forEach(function (g) {
      var list = g.querySelector('.lz-faq__list');
      if (!list) return;
      var nodes = Array.prototype.slice.call(list.querySelectorAll('.lz-faq__item'));
      nodes.sort(function (a, b) {
        var oa = parseInt(a.getAttribute('data-ordre'), 10) || 9999;
        var ob = parseInt(b.getAttribute('data-ordre'), 10) || 9999;
        if (oa !== ob) return oa - ob;
        return a._q.textContent.localeCompare(b._q.textContent, 'fr');
      });
      nodes.forEach(function (n) { list.appendChild(n); });
    });

    var state = { filter: 'all', query: '' };

    function normalize(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
    }

    function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    function highlight(item, terms) {
      if (!terms.length) { item._q.innerHTML = item._qHtml; return; }
      var re = new RegExp('(' + terms.map(escapeRe).join('|') + ')', 'gi');
      // On surligne uniquement dans la question (la réponse contient du HTML riche)
      var plain = item._q.textContent;
      // Comparaison sans accents : on surligne par correspondance sur la version normalisée
      var norm = normalize(plain);
      var out = '', last = 0, m;
      var reNorm = new RegExp('(' + terms.map(escapeRe).join('|') + ')', 'g');
      while ((m = reNorm.exec(norm)) !== null) {
        out += escapeHtml(plain.slice(last, m.index)) + '<mark>' + escapeHtml(plain.slice(m.index, m.index + m[0].length)) + '</mark>';
        last = m.index + m[0].length;
      }
      out += escapeHtml(plain.slice(last));
      item._q.innerHTML = out;
      void re;
    }

    function escapeHtml(s) {
      return s.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function apply() {
      var terms = state.query ? state.query.split(' ').filter(Boolean) : [];
      var visible = 0;

      items.forEach(function (item) {
        var okCat = state.filter === 'all' || item.getAttribute('data-category') === state.filter;
        var okText = terms.every(function (t) { return item._text.indexOf(t) !== -1; });
        var show = okCat && okText;
        item.hidden = !show;
        if (show) {
          visible++;
          highlight(item, terms);
          // Une recherche active ouvre les réponses correspondantes
          if (terms.length) item.open = true;
        } else {
          highlight(item, []);
        }
      });

      groups.forEach(function (g) {
        var any = Array.prototype.some.call(g.querySelectorAll('.lz-faq__item'), function (i) { return !i.hidden; });
        g.hidden = !any;
      });

      if (countEl) countEl.textContent = visible;
      if (noResult) noResult.hidden = visible !== 0;
      if (clearBtn) clearBtn.hidden = !state.query;
    }

    // Recherche
    if (input) {
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          state.query = normalize(input.value);
          if (!state.query) items.forEach(function (i) { i.open = false; });
          apply();
        }, 120);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; input.dispatchEvent(new Event('input')); } });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = ''; input.dispatchEvent(new Event('input')); input.focus();
      });
    }

    // Filtres
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        state.filter = btn.getAttribute('data-filter');
        apply();
      });
    });

    // Accordéon : une seule réponse ouverte à la fois dans un groupe (hors recherche)
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open || state.query) return;
        var group = item.closest('.lz-faq__group');
        if (!group) return;
        Array.prototype.forEach.call(group.querySelectorAll('.lz-faq__item[open]'), function (o) {
          if (o !== item) o.open = false;
        });
      });
    });

    // Ancre directe (#handle) : ouvrir la question visée
    function openFromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (target && target.classList.contains('lz-faq__item')) {
        target.open = true;
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
      }
    }
    if (root.id === 'lz-faq') {
      window.addEventListener('hashchange', openFromHash);
      openFromHash();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
